<template>
  <ul class="files clearfix">
    <li v-for="(val, index) in list" :key="index">
      <div v-if="val.isDir == false">
        <span class="file-icon has-img" v-if="val.isImg">
          <img :src="val.url" alt="Attachment" />
        </span>
        <span v-else class="file-icon"
          ><i :class="'fa ' + val.preview"></i
        ></span>
      </div>
      <div v-else-if="val.isDir == true">
        <router-link
          :to="{
            name: 'CMSMediaManager',
            query: { path: val.name },
          }"
          class="file-name"
          :title="val.name"
        >
          <span class="file-icon text-aqua"><i class="fa fa-folder"></i></span>
        </router-link>
      </div>
      <div class="file-info">
        <router-link
          v-if="val.isDir == true"
          :to="{
            name: 'CMSMediaManager',
            query: { path: val.name },
          }"
          class="file-name"
          :title="val.name"
          >{{ val.name }}</router-link
        >
        <a
          :href="API_ASSET_UPLOAD_URL + 'cms/' + val.name"
          target="_blank"
          v-else-if="val.isDir == false"
          :title="val.name"
          class="file-name"
          >{{ _.replace(val.name, path + "/", "") }}</a
        >
        <span class="file-size"> {{ val.size }}&nbsp; </span>
        <button
          v-if="val.isDir == false"
          @click="copyText(API_ASSET_UPLOAD_URL + 'cms/' + val.name)"
          :title="API_ASSET_UPLOAD_URL + 'cms/' + val.name"
          class="btn btn-info btn-xs m-1"
        >
          <i class="fa fa-clone" aria-hidden="true"></i>
        </button>

        <router-link
          v-if="val.isDir == true"
          :to="{
            name: 'CMSMediaManager',
            query: { path: val.name },
          }"
          class="btn btn-info btn-xs m-1"
          :title="val.name"
        >
          <i class="fa fa-eye" aria-hidden="true"></i>
        </router-link>
        <button
          @click="deleteObject(val)"
          title="Delete"
          class="btn btn-danger btn-xs m-1"
        >
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
      </div>
    </li>
  </ul>
</template>
<script>
import axios from "axios";
import { Notification } from "element-ui";

export default {
  name: "MediaList",
  props: ["list", "path"],
  components: {},
  data: () => ({
    is_loading: false,
  }),
  methods: {
    copyText: function (data) {
      try {
        navigator.clipboard.writeText(data);
        Notification.success({
          title: "Copied",
          message: "URL copied to clipboard successfully",
          type: "success",
        });
      } catch ($e) {
        Notification.error({
          title: "Failed",
          message: "Copy failed! Try again later.",
          type: "error",
        });
      }
    },
    deleteObject: function (data) {
      let _this = this;
      let delete_api_url = "/cms_media_manager/" + data.name;
      _this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            _this.is_loading = true;
            axios
              .delete(delete_api_url)
              .then((response) => {
                _this.$toaster.success(response.data.message);
                _this.is_loading = false;
                _this.$emit("reload");
              })
              .catch((error) => {
                _this.is_loading = false;
                console.log(error);
                _this.$swal.fire("Failed!", "failed to delete.", "error");
              })
              .finally(() => {
                _this.is_loading = false;
              });
          }
        });
    },
  },
};
</script>
